
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

import CircleImage from '../CircleImage/CircleImage.vue';

export default defineComponent({
    name: 'GroundwaterAndSoilGrainSize',
    components: {
        CircleImage
    },
    props: {
        siteDetails: ESARSite
    },
    setup() {}
});
